// 효과음 메타데이터 정의 (폰트 패턴과 동일)

// 카테고리 타입
export type SoundEffectCategory = 'ui' | 'transition' | 'pop' | 'action';

// 효과음 정의 타입
export interface SoundEffectDefinition {
  id: string;
  name: string; // 번역 키로 사용 (SoundEffects.{id})
  path: string; // public 폴더 기준 경로
  duration: number; // ms 단위
  category: SoundEffectCategory;
}

// 카테고리 정보
export const SOUND_EFFECT_CATEGORIES: Record<
  SoundEffectCategory,
  { labelKey: string; order: number }
> = {
  ui: { labelKey: 'Editor.sound-effect.category.ui', order: 1 },
  transition: {
    labelKey: 'Editor.sound-effect.category.transition',
    order: 2,
  },
  pop: {
    labelKey: 'Editor.sound-effect.category.pop',
    order: 3,
  },
  action: { labelKey: 'Editor.sound-effect.category.action', order: 4 },
};

// 효과음 목록
export const SOUND_EFFECTS: SoundEffectDefinition[] = [
  // ============================================
  // UI / 알림 사운드
  // ============================================
  {
    id: 'beep-01',
    name: 'Beep 01',
    path: 'sound-effects/Beep 01.mp3',
    duration: 862,
    category: 'ui',
  },
  {
    id: 'chime-01',
    name: 'Chime 01',
    path: 'sound-effects/Chime 01.mp3',
    duration: 1306,
    category: 'ui',
  },
  {
    id: 'chime-02',
    name: 'Chime 02',
    path: 'sound-effects/Chime 02.mp3',
    duration: 1280,
    category: 'ui',
  },
  {
    id: 'chime-03',
    name: 'Chime 03',
    path: 'sound-effects/Chime 03.mp3',
    duration: 2429,
    category: 'ui',
  },
  {
    id: 'chime-04',
    name: 'Chime 04',
    path: 'sound-effects/Chime 04.wav',
    duration: 1988,
    category: 'ui',
  },
  {
    id: 'chime-05',
    name: 'Chime 05',
    path: 'sound-effects/Chime 05.wav',
    duration: 1999,
    category: 'ui',
  },
  {
    id: 'ding-dong-01',
    name: 'Ding dong 01',
    path: 'sound-effects/Ding dong 01.mp3',
    duration: 2011,
    category: 'ui',
  },
  {
    id: 'ding-dong-02',
    name: 'Ding dong 02',
    path: 'sound-effects/Ding dong 02.mp3',
    duration: 1627,
    category: 'ui',
  },
  {
    id: 'enter-01',
    name: 'Enter 01',
    path: 'sound-effects/Enter 01.mp3',
    duration: 391,
    category: 'ui',
  },
  {
    id: 'error-beep-01',
    name: 'Error beep 01',
    path: 'sound-effects/Error beep 01.mp3',
    duration: 548,
    category: 'ui',
  },
  {
    id: 'mouse-click-01',
    name: 'Mouse click 01',
    path: 'sound-effects/Mouse clik 01.mp3',
    duration: 235,
    category: 'ui',
  },
  {
    id: 'keyboard-typing-01',
    name: 'Keyboard Typing 01',
    path: 'sound-effects/Keyboard Typing 01.mp3',
    duration: 5590,
    category: 'ui',
  },
  {
    id: 'keyboard-typing-02',
    name: 'Keyboard Typing 02',
    path: 'sound-effects/Keyboard Typing 02.wav',
    duration: 4642,
    category: 'ui',
  },

  // ============================================
  // 전환 효과
  // ============================================
  {
    id: 'whoosh-01',
    name: 'Whoosh 01',
    path: 'sound-effects/Whoosh 01.mp3',
    duration: 3168,
    category: 'transition',
  },
  {
    id: 'whoosh-02',
    name: 'Whoosh 02',
    path: 'sound-effects/Whoosh 02.mp3',
    duration: 744,
    category: 'transition',
  },
  {
    id: 'whoosh-03',
    name: 'Whoosh 03',
    path: 'sound-effects/Whoosh 03.mp3',
    duration: 672,
    category: 'transition',
  },
  {
    id: 'fast-forward',
    name: 'Fast forward',
    path: 'sound-effects/Fast forward.mp3',
    duration: 2208,
    category: 'transition',
  },
  {
    id: 'rewind-01',
    name: 'Rewind 01',
    path: 'sound-effects/Rewind 01.mp3',
    duration: 2977,
    category: 'transition',
  },

  // ============================================
  // 팝 / 바운스
  // ============================================
  {
    id: 'pop-01',
    name: 'Pop 01',
    path: 'sound-effects/Pop 01.mp3',
    duration: 339,
    category: 'pop',
  },
  {
    id: 'pop-02',
    name: 'Pop 02',
    path: 'sound-effects/Pop 02.mp3',
    duration: 626,
    category: 'pop',
  },
  {
    id: 'pop-03',
    name: 'Pop 03',
    path: 'sound-effects/Pop 03.mp3',
    duration: 339,
    category: 'pop',
  },
  {
    id: 'pop-04',
    name: 'Pop 04',
    path: 'sound-effects/Pop 04.wav',
    duration: 1999,
    category: 'pop',
  },
  {
    id: 'boing-01',
    name: 'Boing 01',
    path: 'sound-effects/Boing 01.mp3',
    duration: 1080,
    category: 'pop',
  },
  {
    id: 'boing-02',
    name: 'Boing 02',
    path: 'sound-effects/Boing 02.mp3',
    duration: 936,
    category: 'pop',
  },
  {
    id: 'boing-03',
    name: 'Boing 03',
    path: 'sound-effects/Boing 03.mp3',
    duration: 522,
    category: 'pop',
  },
  {
    id: 'spring-bounce-01',
    name: 'Spring Bounce 01',
    path: 'sound-effects/Spring Bounce 01.mp3',
    duration: 2136,
    category: 'pop',
  },
  {
    id: 'spring-bounce-02',
    name: 'Spring Bounce 02',
    path: 'sound-effects/Spring Bounce 02.mp3',
    duration: 1071,
    category: 'pop',
  },
  {
    id: 'spring-bounce-03',
    name: 'Spring Bounce 03',
    path: 'sound-effects/Spring Bounce 03.mp3',
    duration: 1253,
    category: 'pop',
  },
  {
    id: 'bubble-pop-01',
    name: 'Bubble Pop 01',
    path: 'sound-effects/Bubble Pop 01.mp3',
    duration: 685,
    category: 'pop',
  },
  {
    id: 'bubble-pop-02',
    name: 'Bubble Pop 02',
    path: 'sound-effects/Bubble Pop 02.mp3',
    duration: 313,
    category: 'pop',
  },
  {
    id: 'bubble-pop-03',
    name: 'Bubble Pop 03',
    path: 'sound-effects/Bubble Pop 03.wav',
    duration: 1133,
    category: 'pop',
  },

  // ============================================
  // 액션 / 효과
  // ============================================
  {
    id: 'blade-slash-01',
    name: 'Blade slash 01',
    path: 'sound-effects/Blade slash 01.wav',
    duration: 2900,
    category: 'action',
  },
  {
    id: 'boom-01',
    name: 'Boom 01',
    path: 'sound-effects/Boom 01.wav',
    duration: 1148,
    category: 'action',
  },
  {
    id: 'coin-01',
    name: 'Coin 01',
    path: 'sound-effects/Coin 01.mp3',
    duration: 946,
    category: 'action',
  },
  {
    id: 'coin-02',
    name: 'Coin 02',
    path: 'sound-effects/Coin 02.mp3',
    duration: 2248,
    category: 'action',
  },
  {
    id: 'camera-01',
    name: 'Camera 01',
    path: 'sound-effects/Camera 01.mp3',
    duration: 496,
    category: 'action',
  },
  {
    id: 'camera-02',
    name: 'Camera 02',
    path: 'sound-effects/Camera 02.mp3',
    duration: 705,
    category: 'action',
  },
  {
    id: 'finger-snap-01',
    name: 'Finger snap 01',
    path: 'sound-effects/Finger snap 01.wav',
    duration: 1207,
    category: 'action',
  },
  {
    id: 'harp-glissando-01',
    name: 'Harp glissando 01',
    path: 'sound-effects/Harp glissando 01.mp3',
    duration: 3370,
    category: 'action',
  },
  {
    id: 'harp-glissando-02',
    name: 'Harp glissando 02',
    path: 'sound-effects/Harp glissando 02.mp3',
    duration: 4884,
    category: 'action',
  },
  {
    id: 'harp-glissando-03',
    name: 'Harp glissando 03',
    path: 'sound-effects/Harp glissando 03.wav',
    duration: 1689,
    category: 'action',
  },
  {
    id: 'paper-turn-01',
    name: 'Paper Turn 01',
    path: 'sound-effects/Paper Turn 01.mp3',
    duration: 1299,
    category: 'action',
  },
  {
    id: 'paper-turn-02',
    name: 'Paper Turn 02',
    path: 'sound-effects/Paper Turn 02.mp3',
    duration: 1035,
    category: 'action',
  },
  {
    id: 'clock-ticking-01',
    name: 'Clock ticking 01',
    path: 'sound-effects/Clock ticking 01.mp3',
    duration: 2298,
    category: 'action',
  },
];

// ============================================
// 헬퍼 함수들
// ============================================

/**
 * 특정 카테고리의 효과음 목록 반환
 */
export const getSoundEffectsByCategory = (category: SoundEffectCategory) =>
  SOUND_EFFECTS.filter((se) => se.category === category);

/**
 * ID로 효과음 찾기
 */
export const getSoundEffectById = (id: string) =>
  SOUND_EFFECTS.find((se) => se.id === id);

/**
 * 카테고리별로 그룹핑된 효과음 Map 반환
 */
export const getGroupedSoundEffects = () => {
  const grouped = new Map<SoundEffectCategory, SoundEffectDefinition[]>();
  for (const se of SOUND_EFFECTS) {
    if (!grouped.has(se.category)) {
      grouped.set(se.category, []);
    }
    grouped.get(se.category)!.push(se);
  }
  return grouped;
};

/**
 * 정렬된 카테고리 목록 반환
 */
export const getSortedCategories = (): SoundEffectCategory[] => {
  return (Object.keys(SOUND_EFFECT_CATEGORIES) as SoundEffectCategory[]).sort(
    (a, b) =>
      SOUND_EFFECT_CATEGORIES[a].order - SOUND_EFFECT_CATEGORIES[b].order,
  );
};
